import { useState } from "react";
import { Separator } from "react-resizable-panels";

export const CustomSeparator = ({
	onDoubleClick,
}: {
	onDoubleClick: () => void;
}) => {
	const [hover, setHover] = useState(false);

	return (
		<Separator
			onDoubleClick={onDoubleClick}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				width: hover ? "10px" : "8px",
				background: hover ? "#bdbdbd" : "#e0e0e0",
				position: "relative",
				cursor: "col-resize",
				marginLeft: 5,
				marginRight: 5,
				borderRadius: 10,
			}}
		>
			<div
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "3px",
					height: "40px",
					background: hover ? "#616161" : "#9e9e9e",
					borderRadius: "2px",
				}}
			/>
		</Separator>
	);
};
